import { Provider, type BackupVault } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { useDAL } from '@/contexts/useDAL';

import { GcpKmsKeyEditorPanel } from './gcpKmsKeyEditorPanel';

import { ChangeableTextField } from '../text/changeableTextField';

export const GcpKmsTextField = ({
  backupVault,
  setBackupVault,
}: {
  backupVault: BackupVault;
  setBackupVault: (data: BackupVault) => void;
}) => {
  const [openKmsKeyEditor, setOpenKmsKeyEditor] = useState(false);
  const dal = useDAL();
  const { data: scanningAccounts } = dal.cloudAccounts.scanning.useList();
  const gcpScanningAccountId = scanningAccounts?.accounts.find(
    (a) => a.cloudProvider === Provider.Gcp
  )?.id;

  const encryptionKey = backupVault.vaultAttributes.gcp?.encryptionKey;

  // useEffect(() => {
  //   if (gcpScanningAccountId && openKmsKeyEditor) {

  //       .catch((error) => {
  //         console.error('Failed to get CMEK service accounts:', error);
  //       });
  //   }
  // }, [gcpScanningAccountId, openKmsKeyEditor, dal.cloudAccounts.scanning]);

  return (
    <>
      <ChangeableTextField
        value={encryptionKey}
        onClick={() => setOpenKmsKeyEditor(true)}
        placeholder='No key set'
        noValueButtonText='Set Key'
      />
      {gcpScanningAccountId && (
        <GcpKmsKeyEditorPanel
          open={openKmsKeyEditor}
          onClose={() => setOpenKmsKeyEditor(false)}
          data={backupVault}
          setData={setBackupVault}
          scanningAccountId={gcpScanningAccountId}
        />
      )}
    </>
  );
};
